/*@ngInject*/
const DateRangeController = function ($scope, $rootScope, $timeout, formComponentUtil, localization, dateUtil, coreConstant) {

    let timeoutList = [];
    this.isDateDisabled = false;

    this.$onInit = function () {
       this.init();
    };

    this.init = function () {
        let dateRange,
            startDateParts,
            endDateParts;

        if(this.isDisabled) {
            this.isDateDisabled = true;
        }


        if (!_.isNil(this.dateValue)) {
            dateRange = _.split(this.dateValue, '::');
            if (dateRange.length === 3) {
                startDateParts = _.split(dateRange[1], /[-+]/);
                endDateParts = _.split(dateRange[2], /[-+]/);
                this.startDate = startDateParts[0] !== ' ' ? formComponentUtil.formatDateWithDefaultPreferences(startDateParts[0], false) : startDateParts[0];
                this.endDate = endDateParts[0] !== ' ' ? formComponentUtil.formatDateWithDefaultPreferences(endDateParts[0], false) : endDateParts[0];
                this.origStartDate = this.startDate;
                this.origEndDate = this.endDate;

                if ((this.startDate !== ' ' && startDateParts.length === 1) ||
                    (this.endDate !== ' ' && endDateParts.length === 1)) {
                    // timezone offset is missing
                    this.updateValue();
                }
            }
        }

        localization.getTranslationByKey('advancedFilter.dateRange').then(function (translation) {
            this.startDatePlaceHolder = translation.startDatePlaceHolder;
            this.endDatePlaceHolder = translation.endDatePlaceHolder;
        }.bind(this));
    };

    this.handleStartClick = function (event) {
        let isToggleSelected = (event) ? $(event.target).hasClass('toggleCalendarPopup') : false;

        if (this.startPopupOpen && isToggleSelected) {
            this.startPopupOpen = false;
            return;
        }
        if (this.startPopupOpen) {
            this.startDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, false);
            this.updateValue();

            this.startPopupOpen = !this.startPopupOpen;
        } else {
            timeoutList.push($timeout(function () {
                this.startPopupOpen = !this.startPopupOpen;
                this.resetMonthView();
                this.selectedDate = this.selectedStartDate;
            }.bind(this)));
        }
    };

    this.handleEndClick = function (event) {
        let isToggleSelected = (event) ? $(event.target).hasClass('toggleCalendarPopup') : false;

        if (this.endPopupOpen && isToggleSelected) {
            this.endPopupOpen = false;
            return;
        }
        if (this.endPopupOpen) {
            this.endDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, false);
            this.updateValue();

            this.endPopupOpen = !this.endPopupOpen;
        } else {
            timeoutList.push($timeout(function () {
                this.endPopupOpen = !this.endPopupOpen;
                this.resetMonthView();
                this.selectedDate = this.selectedEndDate;
            }.bind(this)));
        }
    };

    this.handleChange = function (event) {
        let isDaySelected = (event) ? $(event.target).parents('.uib-day').length > 0 : false;

        if (isDaySelected) {
            if(this.startPopupOpen) {
                this.startDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, false);
            }
            if(this.endPopupOpen) {
                this.endDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, false);
            }

            if (!_.isNil(this.endDate) && this.endDateValidationErrorMessage) {
                if (dateUtil.isBefore(this.endDate, this.startDate)) {
                    this.endDate = '';
                    $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, this.endDateValidationErrorMessage);
                }
            }

            this.updateValue();
            this.startPopupOpen = false;
            this.endPopupOpen = false;
        }
    };

    this.handleBlur = function () {
        let selectedStartDateCleared,
            selectedEndDateCleared,
            updateStartDate = true,
            updateEndDate = true;

        this.selectedStartDate = formComponentUtil.dateFromInput(this.startDate, false);
        this.selectedEndDate = formComponentUtil.dateFromInput(this.endDate, false);

        selectedStartDateCleared = _.isUndefined(this.selectedStartDate) && !_.isUndefined(this.startDate);
        selectedEndDateCleared = _.isUndefined(this.selectedEndDate) && !_.isUndefined(this.endDate);

        if (!this.allowDateClearing) {
            if (!this.allowIndependentDates) {
                if (selectedStartDateCleared || selectedEndDateCleared) {
                    this.startDate = this.origStartDate;
                    this.endDate = this.origEndDate;
                    updateStartDate = false;
                    updateEndDate = false;
                }
            } else {
                if (selectedStartDateCleared) {
                    this.startDate = this.origStartDate;
                    updateStartDate = false;
                }
                if (selectedEndDateCleared) {
                    this.endDate = this.origEndDate;
                    updateEndDate = false;
                }
            }
        }

        if (updateStartDate) {
            this.startDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedStartDate, false);
        }
        if (updateEndDate) {
            this.endDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedEndDate, false);
        }
        if (updateStartDate || updateEndDate) {
            this.updateValue();
        }
    };

    this.resetMonthView = function () {
        if (_.isUndefined(this.startDate) || this.startDate === '') {
            this.selectedStartDate = undefined;
        } else {
            this.selectedStartDate = formComponentUtil.dateFromInput(this.startDate, false);
        }
        if (_.isUndefined(this.endDate) || this.endDate === '') {
            this.selectedEndDate = undefined;
        } else {
            this.selectedEndDate = formComponentUtil.dateFromInput(this.endDate, false);
        }
    };

    this.updateValue = function () {
        let startDateTimezoneOffset = '+0000',
            endDateTimezoneOffset = '+0000',
            startDateMoment,
            endDateMoment,
            startDate_MM_DD_YYYY_ZZ,
            endDate_MM_DD_YYYY_ZZ;
        if (_.isNil(this.startDate) && _.isNil(this.endDate)) {
            this.dateValue = 'ALL';
        } else {
            if (!this.allowIndependentDates && this.startDate !== this.origStartDate) {
                this.endDate = formComponentUtil.formatDateWithDefaultPreferences(moment(this.startDate).add(1, 'year'), false);
            }

            // convert the formatted date values (can be in MM/DD/YY, MM/DD/YYYY, DD/MM/YYYY) to a moment so that dateValue can be normalized
            startDateMoment = moment(formComponentUtil.dateFromInput(this.startDate, false));
            endDateMoment = moment(formComponentUtil.dateFromInput(this.endDate, false));

            // calculate the timezone offset based on the date; e.g. offset is different during Day Light Savings
            if (this.timezoneMode === 'local') {
                if (this.startDate) {
                    startDateTimezoneOffset = startDateMoment.format('ZZ');
                }
                if (this.endDate) {
                    endDateTimezoneOffset = endDateMoment.format('ZZ');
                }
            }

            startDate_MM_DD_YYYY_ZZ = this.startDate ? startDateMoment.format('MM/DD/YYYY') + startDateTimezoneOffset : ' ';
            endDate_MM_DD_YYYY_ZZ = this.endDate ? endDateMoment.format('MM/DD/YYYY') + endDateTimezoneOffset : ' ';

            // store in the format SPECIFIED::MM/DD/YYYYZZ::MM/DD/YYYYZZ where ZZ is the offset, e.g. +0000, -0400, etc...
            this.dateValue = 'SPECIFIED::' + startDate_MM_DD_YYYY_ZZ + '::' + endDate_MM_DD_YYYY_ZZ;
        }
        this.origStartDate = this.startDate;
        this.origEndDate = this.endDate;
        this.valueUpdated({value: this.dateValue});
    };

    this.isToday = function (date, mode) {
        let today = new Date(),
            year = today.getFullYear();
        today.setHours(12, 0, 0, 0);
        if (today.toDateString() === date.toDateString() || (mode === 'year' && year === date.getFullYear())) {
            return 'today';
        }
    };

    this.handleClose = function () {
        this.startPopupOpen = false;
        this.endPopupOpen = false;
    };

    this.handleKeydown = function (event) {
        if (event.which === 9) {
            this.startPopupOpen = false;
            this.endPopupOpen = false;
        }
        return false;
    };

    $scope.$on(coreConstant.event.REFRESH_DATE_RANGE, function(event){
        this.init();
    }.bind(this))

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });
};

angular.module('umCore')
    .controller('dateRangeController', DateRangeController);
